import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from '../../contexts/AuthContext';
import { Table } from '../common/Table';
import {Loading} from '../common/Loading';

const apiUrl = window._env_?.REACT_APP_API_URL || "https://app.mylocaleventrentals.com/api";

const PaymentsList = () => {

    const navigate = useNavigate();
    const { logout } = useAuth();
    const token = localStorage.getItem("token");
    const [loading, setLoading] = useState(true);
    const [payments, setPayments] = useState([]);
    const columns = [
    { key: 'payment_number', label: 'Payment ID', sortable: true },
    { key: 'date', label: 'Payment Date', sortable: false },
    { key: 'method', label: 'Payment Method', sortable: false },
    { key: 'amount', label: 'Amount', sortable: false },
    { 
      key: 'status', 
      label: 'Status', 
      sortable: true,
      editable: true, 
      editType: 'select',
      options: [
        { value: 'pending', label: 'Pending' },
        { value: 'confirmed', label: 'Confirmed' },
        { value: 'delivered', label: 'Delivered' },
        { value: 'cancelled', label: 'Cancelled' },
        { value: 'completed', label: 'Completed' }
      ],
      render: (value) => {
        const statusColors = {
          pending: 'bg-yellow-100 text-yellow-800',
          confirmed: 'bg-blue-100 text-blue-800',
          delivered: 'bg-green-100 text-green-800',
          cancelled: 'bg-red-100 text-red-800',
          completed: 'bg-purple-100 text-purple-800'
        };
        return (
          <span className={`px-2 py-1 rounded text-xs ${statusColors[value] || 'bg-gray-100 text-gray-800'}`}>
            {value}
          </span>
        );
      }
    },
   {
      key: 'actions',
      label: 'Actions',
      render: (value, row, { isEditing, handleEdit, handleSave, handleCancel }) => {
        if (isEditing) {
          return (
            <div className="flex gap-2">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleSave(row);
                }}
                className="px-3 py-1 text-xs bg-green-600 text-white rounded hover:bg-green-700"
              >
                ✓ Save
              </button>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleCancel();
                }}
                className="px-3 py-1 text-xs bg-gray-600 text-white rounded hover:bg-gray-700"
              >
                ✕ Cancel
              </button>
            </div>
          );
        }

        return (
          <div className="flex gap-2">
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleEdit(row);
              }}
              className="px-3 py-1 text-xs bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Edit
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteItem(row);
              }}
              className="px-3 py-1 text-xs bg-red-600 text-white rounded hover:bg-red-700"
            >
              Delete
            </button>
          </div>
        );
      }
    }
  ];

  useEffect(() => {
    if (!token) {
      logout().then(() => navigate('/login', { replace: true }));
    }
  }, []);

  const fetchPayments = async () => {
  if (!token) return;
  try {
  
    const res = await axios.get(`${apiUrl}/payment`, {
      headers: { "x-auth-token": token },
    });

    setPayments(res.data.data);
  } catch (err) {
    console.error("Error fetching payments:", err);
    if (err.response?.status === 401) {
      await logout();
      navigate('/login', { replace: true });
    }
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    if (token) {
      fetchPayments();
    }
  }, [token]);

  const handleSave = async (data) => {
    if (!token) return;

    try {
      await axios.put(`${apiUrl}/payment/${data.uuid}`, data, {
        headers: { "x-auth-token": token },
      });
      setPayments((prevPayments) =>
        prevPayments.map((p) => (p.uuid === data.uuid ? data : p))
      );
    } catch (err) {
      console.error("Error updating payment:", err);
      if (err.response?.status === 401) {
        await logout();
        navigate('/login', { replace: true });
      }
    }
  };

const handleDeleteItem = async (payment) => {
    if (!token) return;
    const confirmDelete = window.confirm(`Are you sure you want to delete payment ${payment.payment_number}?`);
    if (!confirmDelete) return;
    try {
      await axios.delete(`${apiUrl}/payment/${payment.uuid}`, {
        headers: { "x-auth-token": token },
      });
      setPayments((prevPayments) => prevPayments.filter((p) => p.uuid !== payment.uuid));
    } catch (err) {
      console.error("Error deleting payment:", err);
      if (err.response?.status === 401) {
        await logout();
        navigate('/login', { replace: true });
      }
    }
  };

  if(loading){
      return <Loading/>;
    }
  

  return(
    <div className="p-4 md:p-6 my-2 md:my-6 bg-white shadow-lg rounded-lg">
      <h2 className="text-2xl md:text-3xl font-bold mb-6 text-gray-800">All Payments</h2>

        <Table
        columns={columns}
        data={payments || []}
        paginated={true}
        pageSize={15}
        onRowClick={(payment) => navigate(`/payment/${payment.uuid}`)}
        rowKey="uuid"
        striped={true}
        hoverable={true}
        onSave={handleSave}
        />
    </div>
  );


};


export default PaymentsList;
